import { util } from '@/plugins/util';

const state = {
  searchHistory: util.localStorage.get('soundRecord.searchHistory') || [],
  bgm: null,
  soundRecord: {
    isShowGenerateVoice: false,
    isShowSetRecordName: false,
    uploadingName: '',
    typeOfSetRecordName: 'create', // create | update 新名称弹窗或重命名弹窗
    updatingRecordId: '', // 正在重命名的录音资源id
  }
}

const getters = {
  SoundRecord: state => state.soundRecord,
  TypeOfSetRecordName: state => state.soundRecord.typeOfSetRecordName,
  UpdatingRecordId: state => state.soundRecord.updatingRecordId,
  BGM: state => state.bgm,
  RecordSearchHistory: state => state.searchHistory
}

const mutations = {
  save_SoundRecord (state, data = {}) {
    state.soundRecord = {
      ...state.soundRecord,
      ...data,
    };
  },
  save_bgm (state, data = null) {
    state.bgm = data;
  },
  save_SR_SearchHistory (state, data='') {
    let ii = state.searchHistory.indexOf(data);
    if (ii > -1) {
      let arrPart = state.searchHistory.splice(ii, 1);
      state.searchHistory = [...arrPart, ...state.searchHistory];
      return;
    }
    state.searchHistory = [data, ...state.searchHistory].slice(0, 5);
    util.localStorage.set('soundRecord.searchHistory', state.searchHistory);
  }
}

export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/soundRecord.js